import { useState } from "react";
import { useNavigate } from "react-router-dom";
import StepIndicator from "../components/modules/newPrototype/StepIndicator";
import CostEstimator from "../components/modules/newPrototype/CostEstimator";
import ProjectInfoStep from "../components/modules/newPrototype/ProjectInfoStep";
import UploadFilesStep from "../components/modules/newPrototype/UploadFilesStep";
import ManufacturingProcessStep from "../components/modules/newPrototype/ManufacturingProcessStep";
import SelectCentreStep from "../components/modules/newPrototype/SelectCentreStep";
import ExpertConsultationStep from "../components/modules/newPrototype/ExpertConsultationStep";
import ReviewSubmitStep from "../components/modules/newPrototype/ReviewSubmitStep";

const initialFormData = {
  projectName: "",
  expectedQuantity: "",
  category: "",
  description: "",
  targetDeliveryDate: "",
  files: [],
  process: "",
  centre: "",
  expert: "",
};

const TOTAL_STEPS = 6;

export default function NewPrototype() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState(initialFormData);

  const updateField = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const goNext = () => setStep((s) => Math.min(s + 1, TOTAL_STEPS));
  const goBack = () => setStep((s) => Math.max(s - 1, 1));

  const handleSubmit = () => {
    console.log("Submitting prototype request:", formData);
    navigate("/app/dashboard");
  };

  const stepComponents = {
    1: <ProjectInfoStep formData={formData} updateField={updateField} />,
    2: <UploadFilesStep formData={formData} updateField={updateField} />,
    3: <ManufacturingProcessStep formData={formData} updateField={updateField} />,
    4: <SelectCentreStep formData={formData} updateField={updateField} />,
    5: <ExpertConsultationStep formData={formData} updateField={updateField} />,
    6: <ReviewSubmitStep formData={formData} onSubmit={handleSubmit} />,
  };

  return (
    <div>
      <h1 className="text-3xl font-extrabold text-gray-900">New Prototype Request</h1>
      <p className="text-gray-600 mt-1 mb-6">6 quick steps to submit your build</p>

      <StepIndicator currentStep={step} />

      <div className="grid lg:grid-cols-3 gap-6 items-start">
        <div className="rounded-xl border bg-card text-card-foreground shadow lg:col-span-2 p-6">
          {stepComponents[step]}

          {step < TOTAL_STEPS && (
            <div className="flex items-center justify-between mt-8 pt-6 border-t border-gray-100">
              <button
                type="button"
                onClick={goBack}
                disabled={step === 1}
                className="text-sm font-semibold px-5 py-2.5 rounded-xl border border-gray-200 text-gray-700 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-50 transition"
              >
                Back
              </button>
              <button
                type="button"
                onClick={goNext}
                className="flex items-center gap-2 bg-gradient-to-r from-indigo-600 to-blue-500 text-white text-sm font-semibold px-6 py-2.5 rounded-xl hover:opacity-90 transition"
              >
                Continue →
              </button>
            </div>
          )}
        </div>

        <CostEstimator />
      </div>
    </div>
  );
}